import React, { useEffect, useState, useMemo } from "react";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../environment/BackendService";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";

const usePatientPayScheduleCriteria = () => {
  const { axios_helper_no_header } = useAxios();
  const [data, setData] = useState([]);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const toast = useToast();
  const location = useLocation();

  /*const stateVal = location.state;
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);

  const {
    selectedPatients = [],
    previousScreen = ROUTE_PATHS.PATIENT_PAY_SCHEDULE,
    currentIndex: initialIndex = 0,
    paramsData: initialParamsData = {
      ps3PatientPaySchName:
        selectedPatients[initialIndex]?.ps3PatientPaySchName || "",
      ps3PatientPaySchDesc:
        selectedPatients[initialIndex]?.ps3PatientPaySchDesc || "",
      ppcSeqNbr: "",
    },
  } = currentState;*/

  const [stateVal, setStateVal] = useState(location.state || []);
  const { currentState, previousState } = useMemo(() => {
    let [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    return {
      previousState,
      currentState,
    };
  }, [stateVal]);

  const {
    selectedPatients = [],
    previousScreen = ROUTE_PATHS.PATIENT_PAY_SCHEDULE,
    currentIndex: initialIndex = 0,
    externalMode: initialExternalMode = false,
    paramsData: initialParamsData = {
      ps3PatientPaySchName:
        selectedPatients[initialIndex]?.ps3PatientPaySchName || "",
      ps3PatientPaySchDesc:
        selectedPatients[initialIndex]?.ps3PatientPaySchDesc || "",
      ppcSeqNbr: "",
    },
  } = useMemo(() => {
    const {
      selectedPatients,
      previousScreen,
      currentIndex,
      externalMode,
      paramsData,
    } = currentState;
    return {
      selectedPatients,
      previousScreen,
      currentIndex,
      externalMode,
      paramsData,
    };
  }, [currentState]);

  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [externalMode, setExternalMode] = useState(initialExternalMode);
  const [paramsData, setParamsData] = useState(initialParamsData);

  const {
    PATIENT_PAY_SCHEDULE_CRITERIA_ADD,
    PATIENT_PAY_SCHEDULE_CRITERIA_DISPLAY,
    PATIENT_PAY_SCHEDULE_CRITERIA_EDIT,
    COPY_PRICE_SCHEDULE,
    PRICE_SCHEDULE_NOTE,
  } = ROUTE_PATHS;

  const screen_title = "Patient Pay Schedule Criteria";
  const screenNumber = "RCPPC002";
  //const  ppcSeqNbr = ppcSeqNbr;

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "PS3 Patient Pay Sch Name",
      name: "ps3PatientPaySchName",
      label: "Schedule",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "PS3 Patient Pay Sch Desc",
      name: "ps3PatientPaySchDesc",
      label: "Description",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 25,
    },
    {
      fieldLabel: "PPC Seq Nbr",
      name: "ppcSeqNbr",
      label: "Sequence",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 3,
    },
  ];

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = [
    {
      button_label: "Add Patient Pay Schedule Criteria",
      button_handeler: () => {
        /* const lastScheduleName =
          selectedPatients[currentIndex]?.ps3PatientPaySchName || "";
        const updatedParamsData = {
          ...currentState.paramsData,
          scheduleName: lastScheduleName,
        };*/
        navigateToPage(PATIENT_PAY_SCHEDULE_CRITERIA_ADD, [
          ...previousState,
          {
            ...currentState,
            paramsData: paramsData,
            currentIndex,
            externalMode,
          },
          {
            previousScreen: location.pathname,
            ps3PatientPaySchName:
              selectedPatients[currentIndex]?.ps3PatientPaySchName,
            ps3PatientPaySchDesc:
              selectedPatients[currentIndex]?.ps3PatientPaySchDesc,
          },
        ]);
      },
      button_key: "F6",
    },
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  /* Gear Icon Menu option CTAs */
  const menuOptions = [
    {
      label: "Edit",
      icon: <span className="material-icons">edit</span>,
      command: () => {
        const selectedCriterias = selectedRows.length
          ? selectedRows
          : [rowData];
        const latestSeqNbr =
          selectedCriterias[selectedCriterias.length - 1]?.ppcSeqNbr;
        const updatedParamsData = {
          ...paramsData,
          ppcSeqNbr: latestSeqNbr,
        };
        navigateToPage(PATIENT_PAY_SCHEDULE_CRITERIA_EDIT, [
          ...previousState,
          {
            ...currentState,
            currentIndex,
            paramsData: updatedParamsData,
            externalMode,
          },
          {
            selectedPatientPayScheduleCriterias: selectedRows.length
              ? selectedRows
              : [rowData],
            previousScreen: location.pathname,
            ps3PatientPaySchName:
              selectedPatients[currentIndex]?.ps3PatientPaySchName,
            ps3PatientPaySchDesc:
              selectedPatients[currentIndex]?.ps3PatientPaySchDesc,
            currentIndex: 0,
          },
        ]);
      },
    },
    {
      label: "Delete",
      icon: <span className="material-icons">delete</span>,
      command: () => {
        openConfirmationModal();
      },
    },
    {
      label: "Display",
      icon: <span className="material-icons">visibility</span>,
      command: () => {
        const selectedCriterias = selectedRows.length
          ? selectedRows
          : [rowData];
        const latestSeqNbr =
          selectedCriterias[selectedCriterias.length - 1]?.ppcSeqNbr;
        const updatedParamsData = {
          ...paramsData,
          ppcSeqNbr: latestSeqNbr,
        };
        navigateToPage(PATIENT_PAY_SCHEDULE_CRITERIA_DISPLAY, [
          ...previousState,
          {
            ...currentState,
            currentIndex,
            paramsData: updatedParamsData,
            externalMode,
          },
          {
            selectedPatientPayScheduleCriterias: selectedRows.length
              ? selectedRows
              : [rowData],
            previousScreen: location.pathname,
            ps3PatientPaySchName:
              selectedPatients[currentIndex]?.ps3PatientPaySchName,
            ps3PatientPaySchDesc:
              selectedPatients[currentIndex]?.ps3PatientPaySchDesc,
            currentIndex: 0,
            paramsData: paramsData,
          },
        ]);
      },
    },
  ];

  useEffect(() => {
    setParamsData({
      ...paramsData,
      ps3PatientPaySchName:
        selectedPatients[initialIndex]?.ps3PatientPaySchName || "",
      ps3PatientPaySchDesc:
        selectedPatients[initialIndex]?.ps3PatientPaySchDesc || "",
    });
  }, [externalMode]);

  /* Data table column info. */
  const columnDef = [
    {
      header: "Sequence",
      field: "ppcSeqNbr",
    },
    {
      header: "Claim Status",
      field: "ppcClaimStatus",
    },
    {
      header: "Drug Status",
      field: "ppcPlanDrugSts",
    },
    {
      header: "Dual Status",
      field: "ppcMedicaidDualStsCde",
    },
    {
      header: "Compound",
      field: "ppcCompound",
    },
    {
      header: "Tier",
      field: "ppcTier",
    },
    {
      header: "Speciality",
      field: "ppcSpecialtyFlag",
    },
    {
      header: "OTC Indicator",
      field: "ppcOtcIndicator",
    },
    {
      header: "PSC",
      field: "ppcProductSelectionCde",
    },
    {
      header: "Third Party Exception",
      field: "ppcThirdPartyException",
    },
    {
      header: "Fill Number",
      field: "ppcFillNumber",
    },
    {
      header: "Processing Qualifier",
      field: "ppcProcessingQualifier",
    },
    {
      header: "Multi-Source Code",
      field: "ppcMultiSource",
    },
    {
      header: "Formulary Status Code",
      field: "ppcFormularyStatus",
    },
    {
      header: "State Code",
      field: "ppcStateQualifier",
    },
    {
      header: "Patient Pay Table",
      field: "ppcPatientPayTable",
    },
    {
      header: "TrOOP Accum Code 04 Table",
      field: "ppcEgwp04PatPayTbl",
    },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "ppcSeqNbr"; //ppcSeqNbr

  /* Top Left Back button info that needs to be displayed on the page*/
  const leftButtons = [
    {
      button_label: "Back",
      button_handeler: () => {
        if (externalMode) {
          const message = {
            message: "navigate-to-external-program",
            url: previousScreen,
            parameters: {
              state: [...previousState],
            },
          };
          console.log("back messages", message);
          window.parent.postMessage(message, "*");
        } else if (currentIndex < selectedPatients.length - 1) {
          setCurrentIndex(currentIndex + 1);
        } else {
          navigateToPage(previousScreen, previousState);
        }
      },
      button_key: "F12",
    },
  ];

  /* Handler that fetches the data */
  const fetchData = async () => {
    console.log("fetch data");
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/ppcPatientPayCriteria`,
        null,
        {
          patientPaySchName:
            selectedPatients[currentIndex].ps3PatientPaySchName,
          ppcSeqNbr: paramsData.ppcSeqNbr,
          page: page,
          size: rows,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        console.log("response.length is ", response.length);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        console.log("response", response);
        console.log(pageResponse.totalRecords);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  useEffect(() => {
    if (currentIndex !== initialIndex) {
      setParamsData({
        ps3PatientPaySchName:
          selectedPatients[currentIndex]?.ps3PatientPaySchName,
        ps3PatientPaySchDesc:
          selectedPatients[currentIndex]?.ps3PatientPaySchDesc,
        ppcSeqNbr: "",
      });
    }
  }, [currentIndex]);

  useEffect(() => {
    fetchData();
  }, [paramsData, rows, currentPage, currentIndex]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deletePatientPayScheduleCriteria = () => {
    if (selectedOption === "yes") {
      let ppcSeqNbrs = [];

      if (Array.isArray(selectedRows) && selectedRows.length > 0) {
        ppcSeqNbrs = selectedRows.map((row) => row.ppcSeqNbr);
      } else if (rowData && Object.keys(rowData).length > 0) {
        ppcSeqNbrs[0] = rowData.ppcSeqNbr;
      }

      if (ppcSeqNbrs.length > 0) {
        axios_helper_no_header(
          "DELETE",
          "api/ppcPatientPayCriteria",
          ppcSeqNbrs,
          { patientPaySchName: paramsData.ps3PatientPaySchName }
        )
          .then((response) => {
            const updatedItems = data.filter(
              (item) => item[parmKey] !== rowData[parmKey]
            );
            setTotalRecords((prevTotal) => prevTotal - 1);
            setData(updatedItems);
            //fetchData();
            if (currentPage > 0) {
              setFirst(0);
              setCurrentPage(0);
            } else {
              fetchData();
            }
            toast.current.show({
              severity: "success",
              summary: "",
              detail: response.responseStatus.message,
              life: 3000,
            });
            closeConfirmationModal();
          })
          .catch((error) => {
            console.error("There was an error deleting the data!", error);
            toast.current.show({
              severity: "error",
              summary: "",
              detail: error.message,
              life: 3000,
            });
            closeConfirmationModal();
          });
      } else {
        closeConfirmationModal();
      }
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = new URLSearchParams({
      patientPaySchName: selectedPatients[initialIndex].ps3PatientPaySchName,
    });

    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/ppcPatientPayCriteria/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  const handleMessage = (event) => {
    const { type, data } = event.data;

    if (type === "set-params") {
      setStateVal(data);
      setExternalMode(true);
    }
    console.log("message", event.data);
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  });

  useEffect(() => {
    setCurrentIndex(initialIndex);
  }, [initialIndex]);
  useEffect(() => {
    setExternalMode(initialExternalMode);
  }, [initialExternalMode]);

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deletePatientPayScheduleCriteria,
    setSelectedOption,
  };
};

export default usePatientPayScheduleCriteria;
